export const DEV_URL = process.env.REACT_APP_API_URL;

export const COMMON_HEADERS = {
    "Content-Type": "application/json",
  };
  
export const FORM_DATA_HEADERS = {
    Accept: "application/json",
  };